import { appstr } from "../utils/appstr";
import { SanitizePlanLegacyAdditionalFields } from "../utils/SanitizePlanAdditionalFields";
import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";

export class QGetPlansRFC extends QRFC {
  constructor() {
    super();
  }

  InitGetPlans(callbackObj, wsMgr) {
    this.fWSMgr = wsMgr;
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user) {
    this.AddParameter("mode", "loadplans");
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    if (success) {
      // Temporarily handle legacy plans(that are not versioned as v1) that may have additional fields data in the DB.
      // This would only be holder additional fields data, so convert it to the appropriate format which supports multiple object types.
      const plans = r["plans"].map(plan => {
        if (!Array.isArray(plan.fields)) {
          return plan;
        }
        return {
          ...plan,
          fields: SanitizePlanLegacyAdditionalFields(plan)
        };
      });
      callBackObj.HandlePlans(plans);
    } else {
      var message = appstr(
        "Permission denied to access Planning module. Ensure your role and organization have access to Planning"
      );
      var alertPanel = new QAlert();
      alertPanel.InitAlert(appstr("Planning Access Denied"), message, null, this.fWSMgr);
    }

    this.fWSMgr.PrepRenderWS();
    this.fWSMgr.RenderWS();
  }
}
